module.exports = __webpack_public_path__ + "img/zhuanye.c3bed997.svg";